import {
  useReactMutation,
  getPostServicePromise,
  useTranslation
} from '@invision/core';
import type {
  SecurityRetrieveAuthenticationProviderRequest,
  SecurityRetrieveAuthenticationProviderResponse
} from 'invApi';

export function useRetrieveAuthenticationProviderMutation() {
  const { t } = useTranslation();

  return useReactMutation<
    SecurityRetrieveAuthenticationProviderResponse,
    SecurityRetrieveAuthenticationProviderRequest
  >(
    ['retrieveAuthenticationProvider'],
    (request: SecurityRetrieveAuthenticationProviderRequest) =>
      getPostServicePromise(
        { path: 'Security/RetrieveAuthenticationProvider' },
        {
          payload: request,
          faults: {
            '111': t('Authentication provider configuration not found')
          }
        }
      ),
    {},
    {
      useLoadingIndicator: true,
      errorHandling: 'unhandled' // Let the component handle errors
    }
  );
}
